export enum ECurrency {
  USD = 'USD',
  BRL = 'BRL',
}
